import { nanoid } from "nanoid";
import { ValidationService } from "../../services/validation.service";
import { Coordinate } from "../coordinate.model";

export class MarineMammalInteractionReport {

  reportDate: Date = new Date();

  interactionDate: Date = new Date();

  accidentalContact: boolean = true;

  siteDescription: string = '';

  latitude!: Coordinate;

  longitude!: Coordinate;

  fullName: string = '';

  address: string = '';

  province: string = '';

  phoneNum: string = '';

  email: string = '';

  vesselName: string = '';

  targetedSpecies: string = '';

  fishingGear: string = '';

  gearDamaged: boolean = false;

  gearLost: boolean = false;

  causeKnown: boolean = false;

  lostGearRemark: string = '';

  species: string = '';

  speciesDescription: string = '';

  condition: string = '';

  identificationConfidence: string = '';

  minSpecimens: number = 0;

  maxSpecimens: number = 0;

  bestEstimateSpecimens: number = 0;

  videosRecorded: boolean = false;

  photosTaken: boolean = false;

  samplesTaken: boolean = false;

  documentsAvailable: boolean = false;

  documentRemarks: string = '';

  bodyLengthCategory: string = '';

  bodyLength: string = '';

  eventDescription: string = '';

  incidents: Incident[] = [];

  reportId: string = '';

  internalId: string = '';

  remarks: string = '';

  /* Flags for programmatical use */

  isComplete: boolean = false;

  isSubmitted: boolean = false; // flag that tells us if the report has been sent to DFO

  constructor() {
    this.internalId = 'id-' + nanoid();
  }

  public toString(): string {
    return 'Interaction Date: ' + this.interactionDate;
  }

  public isValid(): boolean {
    return this.isComplete;
  }

  // check if the user's Marine Mammal Reports are defined
  public static transformAnonymous(MarineMammalInteractionReports: any): MarineMammalInteractionReport[] {

    // if it is not defined, set a new one
    if (!MarineMammalInteractionReports) {
      return [];
    }

    let userMarineMammalInteractionReports: MarineMammalInteractionReport[] = [];
    for (let marineMammalInteractionReport of MarineMammalInteractionReports) {
      let userMarineMammalInteractionReport: MarineMammalInteractionReport = new MarineMammalInteractionReport();
      userMarineMammalInteractionReport.internalId = marineMammalInteractionReport.internalId;
      userMarineMammalInteractionReport.reportDate = marineMammalInteractionReport.reportDate;
      userMarineMammalInteractionReport.interactionDate = ValidationService.validateDate(marineMammalInteractionReport.interactionDate);
      userMarineMammalInteractionReport.accidentalContact = marineMammalInteractionReport.accidentalContact;
      userMarineMammalInteractionReport.siteDescription = marineMammalInteractionReport.siteDescription;
      userMarineMammalInteractionReport.latitude = Coordinate.transformAnon(marineMammalInteractionReport.latitude);
      userMarineMammalInteractionReport.longitude = Coordinate.transformAnon(marineMammalInteractionReport.longitude);
      userMarineMammalInteractionReport.fullName = marineMammalInteractionReport.fullName;
      userMarineMammalInteractionReport.address = marineMammalInteractionReport.address;
      userMarineMammalInteractionReport.province = marineMammalInteractionReport.province;
      userMarineMammalInteractionReport.phoneNum = marineMammalInteractionReport.phoneNum;
      userMarineMammalInteractionReport.email = marineMammalInteractionReport.email;
      userMarineMammalInteractionReport.vesselName = marineMammalInteractionReport.vesselName;
      userMarineMammalInteractionReport.targetedSpecies = marineMammalInteractionReport.targetedSpecies;
      userMarineMammalInteractionReport.fishingGear = marineMammalInteractionReport.fishingGear;
      userMarineMammalInteractionReport.gearDamaged = marineMammalInteractionReport.gearDamaged;
      userMarineMammalInteractionReport.gearLost = marineMammalInteractionReport.gearLost;
      userMarineMammalInteractionReport.causeKnown = marineMammalInteractionReport.causeKnown;
      userMarineMammalInteractionReport.lostGearRemark = marineMammalInteractionReport.lostGearRemark;
      userMarineMammalInteractionReport.species = marineMammalInteractionReport.species;
      userMarineMammalInteractionReport.speciesDescription = marineMammalInteractionReport.speciesDescription;
      userMarineMammalInteractionReport.condition = marineMammalInteractionReport.condition;
      userMarineMammalInteractionReport.identificationConfidence = marineMammalInteractionReport.identificationConfidence;
      userMarineMammalInteractionReport.minSpecimens = marineMammalInteractionReport.minSpecimens;
      userMarineMammalInteractionReport.maxSpecimens = marineMammalInteractionReport.maxSpecimens;
      userMarineMammalInteractionReport.bestEstimateSpecimens = marineMammalInteractionReport.bestEstimateSpecimens;
      userMarineMammalInteractionReport.videosRecorded = marineMammalInteractionReport.videosRecorded;
      userMarineMammalInteractionReport.photosTaken = marineMammalInteractionReport.photosTaken;
      userMarineMammalInteractionReport.samplesTaken = marineMammalInteractionReport.samplesTaken;
      userMarineMammalInteractionReport.documentsAvailable = marineMammalInteractionReport.documentsAvailable;
      userMarineMammalInteractionReport.documentRemarks = marineMammalInteractionReport.documentRemarks;
      userMarineMammalInteractionReport.bodyLengthCategory = marineMammalInteractionReport.bodyLengthCategory;
      userMarineMammalInteractionReport.bodyLength = marineMammalInteractionReport.bodyLength;
      userMarineMammalInteractionReport.eventDescription = marineMammalInteractionReport.eventDescription;
      userMarineMammalInteractionReport.incidents = marineMammalInteractionReport.incidents;
      userMarineMammalInteractionReport.reportId = marineMammalInteractionReport.reportId;
      userMarineMammalInteractionReport.isSubmitted = marineMammalInteractionReport.isSubmitted ?? false;
      userMarineMammalInteractionReport.remarks = marineMammalInteractionReport.remarks ?? '';
      userMarineMammalInteractionReports.push(userMarineMammalInteractionReport);
    }
    return userMarineMammalInteractionReports;

  }

}

interface Incident {
  type: string;
  description: string;
}

